import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { IMessageResponse } from '_core/types';
import { SendTokenEmailTypes } from '../Types';

const machine = Machines.onSendTokenEmail.machine;

export const sendTokenEmail = (
  params: SendTokenEmailTypes.SendTokenEmailServiceRequestType,
): Promise<IMessageResponse> => {
  return callServiceMachine(machine, params);
};

export default { sendTokenEmail };
